<template>
  <router-view></router-view>
</template>

<script>
	export default {
		name: 'Admin'
	}
</script>

<style scoped>
  body {
    min-height: 75rem;
    padding-top: 4.5rem;
  }

  .app-container {
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    padding-top: 54px;
    padding-bottom: 54px;
  }
  .m-subheader {
    margin: 30px 30px 0 30px;
    padding: 5px 10px;
  }
</style>
